import { getQuanmaiApi, postCommonApi, putUserApi, getUserApi, getShopApi, postUserApi } from './proxy'
export default class {
    //根据用户ID获取用户信息（个人中心）
    GetUserById(data) {
        return getQuanmaiApi('/Users/getUserById', data);
    }
    //修改个人信息（个人中心）
    EditUser(data) {
        return putUserApi('/api/userinfo', data)
    }
    //获取其他用户的个人信息
    getOtherUserInfo(data) {
        return getQuanmaiApi('/Users/getOtherUserInfo', data);
    }
    //退出登录
    lognOut() {
        return getUserApi('/api/logout', {});
    }
    //获取版本信息
    Getversion() {
        return getQuanmaiApi("/Index/getConf", {})
    }
    //获取未读提醒列表接口
    getUnReadTip(data) {
        return getQuanmaiApi('/Messages/getUnReadTip', data);
    }
    //点击查看提醒
    // c2c代表C2C规则引导,
    // c2c_recomment_guide代表粉丝推荐二维码（引导提示）,
    // zixun代表健康咨询引导,
    // new_card代表新人卡评估引导,
    // user_card代表个人中心卡包引导,
    // agency_team_rule代表我的代理团队（规则引导）,
    // agency_team_develop代表代理商发展下线引导
    getTipById(data) {
        return getQuanmaiApi('/Messages/getTipById', data);
    }
    //获取购物车以及订单各状态数量
    orderCount(data) {
        return getShopApi('/order/order_status_count', data);
    }
    //短信验证码登录
    loginCode(data) {
        return postUserApi('/api/login/code', data);
    }
    //发送短信验证码
    msgSend(data) {
        return postCommonApi('/msg/send', data);
    }
    //绑定第三方登录帐号和手机号(新账号)
    userBind(data) {
        return postUserApi('/api/bind', data);
    }
    //绑定手机号
    phoneBind(data) {
        return postUserApi('/api/phonebind', data);
    }
    //更新用户信息
    userInfo(data) {
        return putUserApi('/api/userinfo', data);
    }
    //获取用户登录信息
    GetuserInfo() {
        return getUserApi('/api/userinfo', {});
    }
    //获取用户详细信息
    userDetail() {
        return getUserApi('/api/user/detail', {});
    }
    //获取当前团购的客户列表
    getMyTeamCustomer(data) {
        return getQuanmaiApi('/Teams/getMyTeamCustomer', data);
    }
    //微信分享
    jsconfig(data){
        return getUserApi('/api/wxai/jsconfig',data);
    }
    
}


// WEBPACK FOOTER //
// ./src/service/userService.js